import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type SyncResourceTriggerMutationVariables = Types.Exact<{
  input: Types.SyncResourceInput;
  shopID?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type SyncResourceTriggerMutationResponse = Pick<Types.Mutation, 'syncResourceTrigger'>;

export const SyncResourceTriggerDocument = `
    mutation SyncResourceTrigger($input: SyncResourceInput!, $shopID: ID) {
  syncResourceTrigger(input: $input, shopID: $shopID)
}
    `;

export const useSyncResourceTriggerMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SyncResourceTriggerMutationResponse,
    TError,
    SyncResourceTriggerMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SyncResourceTriggerMutationResponse,
    TError,
    SyncResourceTriggerMutationVariables,
    TContext
  >(
    ['SyncResourceTrigger'],
    (variables?: SyncResourceTriggerMutationVariables) =>
      appFetcher<SyncResourceTriggerMutationResponse, SyncResourceTriggerMutationVariables>(
        SyncResourceTriggerDocument,
        variables,
      )(),
    options,
  );
};

useSyncResourceTriggerMutation.getKey = () => ['SyncResourceTrigger'];
